<template>
    <div>
        <!-- 添加账户 -->
        <el-card shadow="never">
            <el-row>
                <el-col :span="10" :offset="1">
                    <el-form
                        :model="ruleForm"
                        :rules="rules"
                        ref="ruleForm"
                        status-icon
                        label-width="100px"
                        class="demo-ruleForm"
                    >
                        <el-form-item
                            label="用户账号"
                            prop="userId"
                            v-show="!rePass"
                        >
                            <el-input
                                v-model="ruleForm.userId"
                                placeholder="请输入用户账号"
                                :disabled="disabled"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="用户名称"
                            prop="name"
                            v-show="!rePass"
                        >
                            <el-input
                                v-model="ruleForm.name"
                                placeholder="请输入用户名称"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="销售地点"
                            prop="locationCode"
                            v-show="!rePass"
                        >
                            <!-- <el-input v-model="ruleForm.locationCode" placeholder="请输入地区,例如:华东"></el-input> -->
                            <el-cascader
                                style="width : 280px"
                                placeholder="试试搜索:店铺名"
                                :options="options"
                                :clearable="true"
                                filterable
                                expand-trigger="hover"
                                v-model="selectedOptions3"
                                @change="handleChange"
                            ></el-cascader>
                        </el-form-item>
                        <el-form-item
                            label="用户级别"
                            prop="userLevel"
                            v-show="!rePass"
                        >
                            <!-- <el-input v-model="ruleForm.user" placeholder="请输入用户级别"></el-input> -->
                            <el-radio v-model="ruleForm.userLevel" label="U"
                                >普通用户</el-radio
                            >
                            <el-radio v-model="ruleForm.userLevel" label="A"
                                >管理员</el-radio
                            >
                            <el-radio
                                v-model="ruleForm.userLevel"
                                label="S"
                                v-if="isLevel"
                                >系统管理员</el-radio
                            >
                        </el-form-item>
                        <el-form-item label="密码" prop="password">
                            <el-input
                                type="password"
                                v-model="ruleForm.password"
                                placeholder="请输入密码"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="确认密码" prop="checkPass">
                            <el-input
                                type="password"
                                v-model="ruleForm.checkPass"
                                placeholder="请重新输入密码"
                                clearable
                                @input="change($event)"
                            ></el-input>
                        </el-form-item>

                        <!-- 添加权限 -->
                        <el-row v-show="!rePass">
                            <el-col :span="5">
                                <p style="float:right">添加权限:</p>
                            </el-col>
                            <el-col :span="17" :push="1">
                                <el-tree
                                    :data="data2"
                                    show-checkbox
                                    :default-expand-all="defaultExpantAll"
                                    :default-expanded-keys="defaultKeys"
                                    :default-checked-keys="defaultKeys"
                                    node-key="id"
                                    ref="tree"
                                    highlight-current
                                    :props="defaultProps"
                                >
                                </el-tree>
                            </el-col>
                        </el-row>
                        <el-form-item class="submit">
                            <el-button
                                type="primary"
                                @click="submitForm('ruleForm')"
                                >保存</el-button
                            >
                            <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
                            <el-button @click="cancel">返回</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>
<style lang="less">
.submit {
    margin-top: 20px;
}
.el-radio + .el-radio {
    margin-left: 6px !important;
}
</style>
<script>
import axios from '../../env/axios'
import apis from '../../env/apis'
import requestMixin from '../../mixins/request'
import common from '../../mixins/common'
import { getNowFormatDate } from '../../env/util';
import authList from '../../mock/auth.json'

export default {
    mixins: [requestMixin, common],
    inject: ['reload'],
    data () {
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } 
            else {
                if (this.ruleForm.checkPass !== '') {
                    this.$refs.ruleForm.validateField('checkPass');
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            let checkPass = this.ruleForm.checkPass;
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (checkPass !== this.ruleForm.password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            disabled: false,
            defaultExpantAll: false,
            defaultKeys: null,     //默认展开
            defaultChecked: null, //默认选中
            rePass: true,
            data2: authList.data,     // 地区json 
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            input10: '',
            ruleForm: {
                userId: '',
                name: '',
                phone:'',
                locationCode: '',
                userLevel: '',
                password: '',
                checkPass: '',  //重新输入密码
                accessLevel: ''
            },
            rules: {
                userId: [
                    { required: true, message: '请输入用户账号', trigger: 'change' },
                    { min: 3, max: 10, message: '长度在 3 到 10 个字符', trigger: 'change' }
                ],
                name: [
                    { required: true, message: '请输入用户名称', trigger: 'blur' },
                    { min: 3, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '请输入联系方式', trigger: 'blur' },
                    { min: 11, max: 13, message: '长度在 11 到 13 个字符', trigger: 'blur' }
                ],
                locationCode: [
                    { required: true, message: '请选择销售地区', trigger: 'blur' },
                    // { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
                ],
                userLevel: [
                    { required: true, message: '请输入用户级别', trigger: 'blur' },
                    { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
                ],
                password: [
                    { validator: validatePass, trigger: 'blur', required: true },
                    { min: 3, max: 15, message: '长度在 3 到 15 个字符', trigger: 'blur' }
                ],
                checkPass: [
                    { validator: validatePass2, trigger: 'blur', required: true },
                    { min: 3, max: 15, message: '长度在 3 到 15 个字符', trigger: 'blur' }
                ],
            },
            options: [],   // json 
            selectedOptions3: null,
            mulAddress: [],
            radio: 'userLevel',  //用户级别
            isLevel: false,

        };
    },
    created () {

    },
    mounted () {
        //-1.主要判断是添加还是删除
        let index = this.$route.query.index;

        if (index != undefined) {
            this.$nextTick(function () {
                this.reviseUser();
            })
        } else {
            this.rePass = false; //false为展开
        }

        this.$nextTick(function () {
            this.loadingArea();
            this.isLevel = this.IsLevel();

        })
    },
    watch: {
        'ruleForm.userLevel': {
            deep: true,
            handler: function (newVal, oldVal) {
                // console.log(newVal)
                if (newVal == 'A' || newVal == "S") {
                    this.setCheckedKeys();
                } else if (newVal == 'U') {
                    this.cancelCheckedKey();
                }
            }
        },
        //监听直接userid转大写
        'ruleForm.userId': {
            deep: true,
            handler: function (newVal, oldVal) {
                newVal = newVal.toUpperCase();
                this.ruleForm.userId = newVal;
            }
        }
    },
    methods: {
        change(){
            this.$forceUpdate();
        },
        /**
         * 加载地区选项
        */
        loadingArea () {
            //this.loading = true;
             let userId = sessionStorage.getItem("userId") ;
            let params = {
                act: 'findLocations',
                userId
            }
            this.findType(params).then((res) => {
                if (res.data.status == true) {
                    //this.loading = false;
                    let result = res.data.list;
                    let location = result.map((elem, index, arr) => {
                        return { value: elem.locationCode, label: elem.description }
                    })
                    console.log(location);
                    //this.sortChinese(location,"label");
                    this.options = location;
                }

            })
        },
        /**
         * 设置全选操作
         */
        setCheckedKeys () {
            //let accessLevel = this.ruleForm.accessLevel;
            let data2 = this.data2;
            let accessLevel = data2.map(x => {
                return x.id
            });//[1,2,3,4,5]
            this.$refs.tree.setCheckedKeys(accessLevel);

            // data2.forEach((item,index) => {
            //   item.disabled = true
            //   item.children.forEach((item1,index1)=>{
            //     item1.disabled = true;
            //     if(item1.hasOwnProperty('children')){
            //       item1.children.forEach( (item2,index) => {
            //         item2.disabled = true;
            //       })
            //     }
            //   })
            // })

        },
        /**
         * 取消全选操作
         */
        cancelCheckedKey () {
            let data2 = this.data2;
            // let accessLevel = data2.map(x => {
            //   return x.id
            // });//[1,2,3,4,5]
            //console.log(accessLevel)
            // data2.forEach((item,index) => {
            //   item.disabled = false;
            //   item.children.forEach((item1,index1)=>{
            //     item1.disabled = false;
            //     if(item1.hasOwnProperty('children')){
            //       item1.children.forEach( (item2,index) => {
            //         item2.disabled = false;
            //       })
            //     }
            //   })
            // })
            this.$refs.tree.setCheckedKeys([]);
        },
        /**
         * 保存,提交账户信息
         */
        submitForm (formName) {
            let that = this;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let formNamesVal = this.$refs[formName].$options.propsData.model;
                    let accessLevel2 = this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys());
                    let accessLevel = this.$refs.tree.getCheckedKeys();
                    let userId = formNamesVal.userId;
                    let userLevel = that.radio;
                    // formNamesVal.user = userLevel;
                    // console.log(formNamesVal.accessLevel)

                    //通过key获取
                    // console.log(accessLevel2);  //[1,4]
                    // console.log(accessLevel);  //[1,4]

                    //跳转到add页面，并自动请求后台
                    let index = that.$route.query.index;
                    if (!formNamesVal.password) {
                        that.$message({
                            showClose: true,
                            message: '请输入用户密码',
                            type: 'error'
                        });
                    }
                    let userParams = {
                        act: "addUser",
                        name: formNamesVal.name.replace(/\s/ig, ''),       //用户名
                        staffId: formNamesVal.userId.replace(/\s/ig, ''),   //工号
                        password: formNamesVal.password.replace(/\s/ig, ''),   //密码
                        accessLevel: accessLevel2.join(',').replace(/\s/ig, ''),   //用户权限
                        userId: userId.replace(/\s/ig, ''),     //用户名id
                        userLevel: formNamesVal.userLevel.replace(/\s/ig, ''),   //用户级别
                        locationCode: formNamesVal.locationCode.replace(/\s/ig, '') ,  //店铺ID 
                        phone: formNamesVal.phone.replace(/\s/ig, '')
                    }
                    if (index != undefined) {
                        userParams.act = 'updateUser';
                        this.updateUser(userParams);
                    } else {
                        this.addUser(userParams)
                    }

                } else {
                    //console.log('error submit!!');
                    return false;
                }
            });
        },

        /**重置按钮 */
        resetForm (formName) {
            this.$refs[formName].resetFields();
        },

        /**
         * @cancel 取消返回上一页
         */
        cancel () {
            this.$router.go(-1)
        },

        /*修改用户信息 */
        reviseUser () {
            debugger
            let that = this;
            let index = that.$route.query.index;
            let rePass = that.$route.query.rePass; //false
            //console.log(rePass)
            if (rePass == undefined && index !== undefined) {
                that.rePass = rePass;
            }
            that.findAllUser().then(function (data) {
                that.disabled = true;
                //获取半选状态的父级
                // let parent = this.$refs.tree.getHalfCheckedKeys();
                // console.log(parent)
                //that.sortChinese(data,"userId"); //排序
                that.ruleForm = data[index];
                // console.log(that.ruleForm)
                that.ruleForm.checkPass = data[index].password;//默认重输入密码
                if (that.ruleForm.hasOwnProperty("accessLevel")) {
                    that.defaultKeys = that.ruleForm.accessLevel.split(','); //默认选中
                    let data2 = that.data2;
                    let choose = that.defaultKeys;
                    data2.forEach((v, k) => {
                        if (choose.includes(String(v.id))) {
                            if (v.hasOwnProperty('children') && v.children.find(item => choose.includes(String(item.id)))) {
                                choose.splice(choose.findIndex((x) => { return x == v.id }), 1);
                                v.children.forEach((m, n) => {
                                    if (m.hasOwnProperty('children') && m.children.find(item1 => choose.includes(String(item1.id)))) {
                                        choose.splice(choose.findIndex((x) => { return x == m.id }), 1);
                                    }
                                })

                            }
                        }
                    })


                    // for (let [index,val] of data2.entries()){

                    //   for(let [index1,val1] of that.defaultKeys.entries()){
                    //     if(val.id == val1){
                    //       that.defaultKeys.splice(index1,1)
                    //         if( val.hasOwnProperty('children') ){
                    //         console.log( val );
                    //       }

                    //     }

                    //   }
                    // }

                    /*---------------------------- */

                    // var arr = that.defaultKeys; //后台返回的id组成的数组
                    // var newArr = [];
                    // var item = '';
                    // arr.forEach(item =>{
                    //     checked(item,that.data2,newArr)
                    // })
                    // that.defaultKeys = newArr;
                    // function checked(id,data,newArr){
                    //   data.forEach(item => {
                    //       if(item.id == id){
                    //         console.log(id)
                    //         if( item.children.length == 0 ){
                    //             newArr.push(item.id)
                    //           }
                    //       }else{
                    //            console.log(item.children)
                    //           if( item.children.length != 0 ){
                    //              checked(id,item.children,newArr)
                    //           }
                    //         }
                    //     });
                    // };

                    /*---------------------------- */


                }
                if (that.ruleForm.hasOwnProperty("locationCode")) {
                    that.selectedOptions3 = [that.ruleForm.locationCode];
                }
            });

        },

        /**
         * 选择地区
         */
        handleChange (value) {
            console.log(value)
            this.ruleForm.locationCode = value.join('-'); // '华东-新旺茶餐厅-嘉里城店'
        },
        /**
         * 添加用户
         */
        async addUser (params) {
        
            await axios.post(apis.baseURL, params)
                .then((res) => {
                    //console.log(res)
                    if (res.data.status == true) {
                        this.$confirm('添加成功', '提示', {
                            confirmButtonText: '确定',
                            showCancelButton: false,
                            type: 'success'
                        }).then(() => {
                            //确定 - 刷新表单
                            this.reload();
                        }).catch(() => {
                            //取消 - 跳转
                            this.promptMsg('已取消', 'info');
                        })
                    } else {
                        if (res.data.msg) {
                            this.$alert(res.data.msg, '提示', {
                                confirmButtonText: '确定',
                                type: 'warning',
                                center: true
                            });
                        } else {
                            // console.log(res.data)
                            this.$alert('添加失败', '提示', {
                                confirmButtonText: '确定',
                                type: 'warning',
                                center: true
                            });
                        }

                    }
                })
                .catch((error) => {
                    // console.log(error)
                    this.$message({
                        showClose: true,
                        message: '数据请求错误',
                        type: 'error'
                    });
                });
        },
        /**
         * 更新用户
         */
        async updateUser (params) {
            await axios.post(apis.baseURL, params).then((res) => {
                // console.log(res)
                if (res.data.status == true) {
                    this.promptMsg('更新用户成功', 'success')
                    this.$router.push({ path: '/system/permission' })//跳转
                } else {
                    this.promptMsg('更新用户失败', 'error')
                }
            }).catch((error) => {
                this.$message({
                    showClose: true,
                    message: '数据请求错误',
                    type: 'error'
                });
            })
        },
        IsLevel () {
            let level = sessionStorage.getItem('userLevel');
            return level == "S"
        }
    },

    computed: {

    }

}
</script>
